module.exports = __webpack_public_path__ + "static/img/silhouette_03.320e2e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/silhouettes/thumbnail/silhouette_03.png
// module id = Tcs+
// module chunks = 0